import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
export const statisticsvillagerewardinfolistModel = {
    // 数据统计-奖扶对象统计表 CGX
    async statisticsvillagerewardinfolist(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~sfmakfj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticsvillagerewardinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}
export const createstatisticsvillagerewardinfoModel = {
    // 报表统计-奖扶对象统计表-生成 CGX
    async createstatisticsvillagerewardinfo(reward_year,region_level,region_id) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~sfmakfj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticsvillagerewardinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id, 'get', null, null)
    },
}
export const statisticsvillagerewarddetailslistModel = {
    // 数据统计-奖扶对象统计表 CGX
    async statisticsvillagerewarddetailslist(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~sfmakfj',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticsvillagerewarddetailslist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}
export const statisticstownrewardinfoexitlistModel = {

    // 数据分析-城镇奖扶退出情况汇总表 HYT
    async statisticstownrewardinfoexitlist(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken +'~qwe879',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticstownrewardinfoexitlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}

export const statisticstownrewardinfopeoplelistModel = {
    // 数据分析-城镇奖扶人数汇总表 HYT
    // /statisticstownrewardinfopeoplelist
    async statisticstownrewardinfopeoplelistModel(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~asd74',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticstownrewardinfopeoplelist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}
export const statisticsspecialassistanceinfolistModel = {
    // 数据分析-特扶对象实施情况统计表 HYT
    // /statisticsspecialassistanceinfolist
    async statisticsspecialassistanceinfolist(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~a2asd98',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticsspecialassistanceinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}
export const statisticsspecialassistanceinforenewlistModel = {
    // 数据分析-特扶对象实施情况统计表 HYT
    // /statisticsspecialassistanceinforenewlist
    async statisticsspecialassistanceinforenewlist(reward_year,region_level,region_id,filter_level) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~SDFG654',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'statisticsspecialassistanceinforenewlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&reward_year=' + reward_year + '&region_level=' + region_level + '&region_id=' + region_id + '&filter_level=' + filter_level, 'get', null, null)
    },
}


